import { render } from "./PostCardCommentList.vue?vue&type=template&id=027e156e&scoped=true"
import script from "./PostCardCommentList.vue?vue&type=script&lang=js"
export * from "./PostCardCommentList.vue?vue&type=script&lang=js"

import "./PostCardCommentList.vue?vue&type=style&index=0&id=027e156e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027e156e"]])

export default __exports__